// extracted by mini-css-extract-plugin
export default {"bymaHelpBox":"BymaHelpBox_bymaHelpBox__ISiKG","cardHeader":"BymaHelpBox_cardHeader__+X06T","cardBody":"BymaHelpBox_cardBody__mCjf6"};